import React, { useMemo } from "react";
import ReusableForm from "../../../../../../components/reusable/ReusableForm";

const CreateTeam = ({
    isOpen,
    loading = false,
    error = "",
    options = {},
    initialValues = {},
    isEdit = false,
    onClose,
    onSubmit,
}) => {
    // const offices = options.offices || [];
    // const departments = options.departments || [];
    // const employees = options.employees || options.team_leads || [];

    // OFFICE OPTIONS
    const officeOptions = useMemo(
        () =>
            (options.offices || []).map((office) => ({
                value: office.id,
                label: office.name || office.code || `Office ${office.id}`,
            })),
        [options.offices]
    );

    // DEPARTMENT OPTIONS
    const departmentOptions = useMemo(
        () =>
            (options.departments || []).map((department) => ({
                value: department.id,
                label: department.name || department.code || `Department ${department.id}`,
            })),
        [options.departments]
    );

    // TEAM LEAD OPTIONS
    const employeeOptions = useMemo(
        () =>
            (options.employees || options.team_leads || []).map((employee) => ({
                value: employee.id,
                label:
                    employee.name ||
                    employee.user_name ||
                    employee.employee_name ||
                    employee.user_full_name ||
                    employee.email ||
                    `Employee ${employee.id}`,
            })),
        [options.employees, options.team_leads]
    );

    // FORM FIELDS
    const fields = [
        {
            name: "name",
            label: "Team Name",
            type: "text",
            required: true,
            placeholder: "Enter team name",
        },

        {
            name: "code",
            label: "Team Code",
            type: "text",
            required: true,
            placeholder: "Enter team code",
        },

        {
            name: "office",
            label: "Office",
            type: "select",
            required: false,
            placeholder: "Select office",
            options: officeOptions,
        },

        {
            name: "department",
            label: "Department",
            type: "select",
            required: false,
            placeholder: "Select department",
            options: departmentOptions,
        },

        {
            name: "team_lead",
            label: "Team Lead",
            type: "select",
            required: false,
            placeholder: "Select team lead",
            options: employeeOptions,
        },

        {
            name: "description",
            label: "Description",
            type: "textarea",
            required: false,
            placeholder: "Enter team description",
        },
    ];

    // SUBMIT
    const handleSubmit = async (data) => {
        const payload = {
            name: data.name?.trim() || "",
            code: data.code?.trim() || "",
            office: data.office ? Number(data.office) : null,
            department: data.department ? Number(data.department) : null,
            team_lead: data.team_lead ? Number(data.team_lead) : null,
            description: data.description?.trim() || "",
        };

        await onSubmit?.(payload);
    };

    return (
        <>
            {error && isOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2000,
                        maxWidth: "500px",
                        width: "calc(100% - 40px)",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        background: "#fef2f2",
                        color: "#b91c1c",
                        border: "1px solid #fecaca",
                        boxShadow: "0 10px 30px rgba(0,0,0,.12)",
                    }}
                >
                    {error}
                </div>
            )}

            <ReusableForm
                isOpen={isOpen}
                onClose={onClose}
                title={isEdit ? "Edit Team" : "Create Team"}
                fields={fields}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                submitLabel={
                    loading
                        ? "Saving..."
                        : isEdit
                        ? "Update Team"
                        : "Create Team"
                }
            />
        </>
    );
};

export default CreateTeam;
